module.exports = require('./helpers/bundle-url').getBundleURL('38Muk') + "file-cabinet-image.ffe632b4.svg";